import { $isListItemNode } from '@lexical/list';
import { $isRootNode, type LexicalNode, type RangeSelection } from 'lexical';

export function $spansMultipleBlocks(selection: RangeSelection): boolean {
  const anchorNode = selection.anchor.getNode();
  const focusNode = selection.focus.getNode();
  if ($isRootNode(anchorNode) || $isRootNode(focusNode)) return true;
  return $getBlock(anchorNode) !== $getBlock(focusNode);
}

function $getBlock(node: LexicalNode): LexicalNode {
  let current: LexicalNode = node;
  while (!$isListItemNode(current)) {
    const parent = current.getParent();
    if (!parent || $isRootNode(parent)) return current;
    current = parent;
  }
  return current;
}
